import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

export const LoadMoreTrigger = ({ onVisible }: any) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  useEffect(() => {
    if (inView) {
      onVisible();
    }
  }, [inView, onVisible]);

  return <div ref={ref} style={{ height: 1 }} />;
};
